export const UserActionTypes = {
    FETCH_CALENDERS_REQUEST: "@@User/FETCH_CALENDERS_REQUEST",
    FETCH_CALENDERS_SUCCESS: "@@User/FETCH_CALENDERS_SUCCESS",
    FETCH_CALENDERS_FAILURE: "@@User/FETCH_CALENDERS_FAILURE",

    PRESIGNUP_PHONE_REQUEST: "@@User/PRESIGNUP_PHONE_REQUEST",
    PRESIGNUP_PHONE_SUCCESS: "@@User/PRESIGNUP_PHONE_SUCCESS",
    PRESIGNUP_PHONE_FAILURE: "@@User/PRESIGNUP_PHONE_FAILURE",

    SIGNUP_PHONE_REQUEST: "@@User/SIGNUP_PHONE_REQUEST",
    SIGNUP_PHONE_SUCCESS: "@@User/SIGNUP_PHONE_SUCCESS",
    SIGNUP_PHONE_FAILURE: "@@User/SIGNUP_PHONE_FAILURE",

    PRESIGNUP_EMAIL_REQUEST: "@@User/PRESIGNUP_EMAIL_REQUEST",
    PRESIGNUP_EMAIL_SUCCESS: "@@User/PRESIGNUP_EMAIL_SUCCESS",
    PRESIGNUP_EMAIL_FAILURE: "@@User/PRESIGNUP_EMAIL_FAILURE",

    SIGNUP_EMAIL_REQUEST: "@@User/SIGNUP_EMAIL_REQUEST",
    SIGNUP_EMAIL_SUCCESS: "@@User/SIGNUP_EMAIL_SUCCESS",
    SIGNUP_EMAIL_FAILURE: "@@User/SIGNUP_EMAIL_FAILURE",

    LOGIN_GOOGLE_REQUEST: "@@User/LOGIN_GOOGLE_REQUEST",
    LOGIN_GOOGLE_SUCCESS: "@@User/LOGIN_GOOGLE_SUCCESS",
    LOGIN_GOOGLE_FAILURE: "@@User/LOGIN_GOOGLE_FAILURE",

    LOGIN_TWITTER_REQUEST: "@@User/LOGIN_TWITTER_REQUEST",
    LOGIN_TWITTER_SUCCESS: "@@User/LOGIN_TWITTER_SUCCESS",
    LOGIN_TWITTER_FAILURE: "@@User/LOGIN_TWITTER_FAILURE",

    LOGIN_PASSWORD_REQUEST: "@@User/LOGIN_PASSWORD_REQUEST",
    LOGIN_PASSWORD_SUCCESS: "@@User/LOGIN_PASSWORD_SUCCESS",
    LOGIN_PASSWORD_FAILURE: "@@User/LOGIN_PASSWORD_FAILURE",

    CHANGE_PASSWORD_REQUEST: "@@User/CHANGE_PASSWORD_REQUEST",
    CHANGE_PASSWORD_SUCCESS: "@@User/CHANGE_PASSWORD_SUCCESS",
    CHANGE_PASSWORD_FAILURE: "@@User/CHANGE_PASSWORD_FAILURE",

    FORGOT_PASSWORD_REQUEST: "@@User/FORGOT_PASSWORD_REQUEST",
    FORGOT_PASSWORD_SUCCESS: "@@User/FORGOT_PASSWORD_SUCCESS",
    FORGOT_PASSWORD_FAILURE: "@@User/FORGOT_PASSWORD_FAILURE",

    FETCH_USER_PROFILE_REQUEST: "@@User/FETCH_USER_PROFILE_REQUEST",
    FETCH_USER_PROFILE_SUCCESS: "@@User/FETCH_USER_PROFILE_SUCCESS",
    FETCH_USER_PROFILE_FAILURE: "@@User/FETCH_USER_PROFILE_FAILURE",

    UPDATE_USER_PROFILE_REQUEST: "@@User/UPDATE_USER_PROFILE_REQUEST",
    UPDATE_USER_PROFILE_SUCCESS: "@@User/UPDATE_USER_PROFILE_SUCCESS",
    UPDATE_USER_PROFILE_FAILURE: "@@User/UPDATE_USER_PROFILE_FAILURE",

    SEND_OTP_REQUEST: "@@User/SEND_OTP_REQUEST",
    SEND_OTP_SUCCESS: "@@User/SEND_OTP_SUCCESS",
    SEND_OTP_FAILURE: "@@User/SEND_OTP_FAILURE",

    USER_LOGOUT: "@@User/USER_LOGOUT",
    RESET_USER: "@@User/RESET_USER",

    SEARCH_USER_REQUEST: "@@User/SEARCH_USER_REQUEST",
    SEARCH_USER_SUCCESS: "@@User/SEARCH_USER_SUCCESS",
    SEARCH_USER_FAILURE: "@@User/SEARCH_USER_FAILURE",

    CHECK_USER_REQUEST: "@@User/CHECK_USER_REQUEST",
    CHECK_USER_SUCCESS: "@@User/CHECK_USER_SUCCESS",
    CHECK_USER_FAILURE: "@@User/CHECK_USER_FAILURE",

    FOLLOW_USER_REQUEST: "@@User/FOLLOW_USER_REQUEST",
    FOLLOW_USER_SUCCESS: "@@User/FOLLOW_USER_SUCCESS",
    FOLLOW_USER_FAILURE: "@@User/FOLLOW_USER_FAILURE",

    UNFOLLOW_USER_REQUEST: "@@User/UNFOLLOW_USER_REQUEST",
    UNFOLLOW_USER_SUCCESS: "@@User/UNFOLLOW_USER_SUCCESS",
    UNFOLLOW_USER_FAILURE: "@@User/UNFOLLOW_USER_FAILURE",

    FETCH_FOLLOWER_USER_REQUEST: "@@User/FETCH_FOLLOWER_USER_REQUEST",
    FETCH_FOLLOWER_USER_SUCCESS: "@@User/FETCH_FOLLOWER_USER_SUCCESS",
    FETCH_FOLLOWER_USER_FAILURE: "@@User/FETCH_FOLLOWER_USER_FAILURE",

    FETCH_SUBSCRIBER_LIST_REQUEST: "@@User/FETCH_SUBSCRIBER_LIST_REQUEST",
    FETCH_SUBSCRIBER_LIST_SUCCESS: "@@User/FETCH_SUBSCRIBER_LIST_SUCCESS",
    FETCH_SUBSCRIBER_LIST_FAILURE: "@@User/FETCH_SUBSCRIBER_LIST_FAILURE",

    FETCH_OTHER_PROFILE_REQUEST: "@@User/FETCH_OTHER_PROFILE_REQUEST",
    FETCH_OTHER_PROFILE_SUCCESS: "@@User/FETCH_OTHER_PROFILE_SUCCESS",
    FETCH_OTHER_PROFILE_FAILURE: "@@User/FETCH_OTHER_PROFILE_FAILURE",

    ADD_REFER_CODE_REQUEST: "@@User/ADD_REFER_CODE_REQUEST",
    ADD_REFER_CODE_SUCCESS: "@@User/ADD_REFER_CODE_SUCCESS",
    ADD_REFER_CODE_FAILURE: "@@User/ADD_REFER_CODE_FAILURE",

    FETCH_MY_SUBSCRIPTIONS_REQUEST: "@@User/FETCH_MY_SUBSCRIPTIONS_REQUEST",
    FETCH_MY_SUBSCRIPTIONS_SUCCESS: "@@User/FETCH_MY_SUBSCRIPTIONS_SUCCESS",
    FETCH_MY_SUBSCRIPTIONS_FAILURE: "@@User/FETCH_MY_SUBSCRIPTIONS_FAILURE",
};
